"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _debug = _interopRequireDefault(require("debug"));
var _pimAuthConstants = require("@bp/pim-auth-constants");
const debugLog = (0, _debug.default)(`claims:permission-checker:debug`);
class ClaimsPermissionChecker {
  constructor(profile, organization, roles, user, omniOrganization, application) {
    this.profile = void 0;
    this.organization = void 0;
    this.user = void 0;
    this.roles = void 0;
    this.omniOrganization = void 0;
    this.application = void 0;
    this.profile = profile;
    this.organization = organization;
    this.user = user;
    this.roles = roles;
    this.omniOrganization = omniOrganization;
    this.application = application;
  }
  is(profile) {
    return this.profile.uuid === profile.uuid;
  }
  isOrganizationMember(organization) {
    return this.profile.organization.uuid === organization.uuid;
  }
  hasRole(roleName, targetType, targetUuid) {
    for (const role of this.roles) {
      if (role.name === roleName && role.target.type === targetType && role.target.uuid === targetUuid) {
        return true;
      }
    }
    return false;
  }
  hasOrganizationRole(roleName, organization) {
    return this.hasRole(roleName, "Organization", organization ? organization.uuid : this.organization.uuid);
  }

  // there is one other place to change this - since  pim-auth-server does not have this package
  // accounts.ts in pim-auth-server
  canImpersonateProfile(profile) {
    return profile.roles.includes(_pimAuthConstants.ProfileRoles.Parent) ||
    // this.isOrganizationAdmin(profile.organization) ||
    this.isOmniAdmin();
  }
  isOrganizationAdmin(organization) {
    return this.hasOrganizationRole(_pimAuthConstants.AdminRoles.OrganizationAdmin, organization);
  }
  isOmniAdmin() {
    var _this$user;
    return this.isOrganizationAdmin(this.omniOrganization) || ((_this$user = this.user) == null ? void 0 : _this$user.isOmniAdmin) === true;
  }
  hasGroupRole(roleName, group) {
    return this.hasRole(roleName, "Group", group.uuid);
  }
  isGroupAdmin(group) {
    return this.hasGroupRole(_pimAuthConstants.GroupRoles.Admin, group);
  }
  isProfileAdmin(profile) {
    return this.hasGroupRole(_pimAuthConstants.GroupRoles.Admin, profile);
  }
  canCreateOrganization() {
    return this.isOmniAdmin(); // Only omni-admin can create organizations
  }
  canUpdateOrganization(organization) {
    if (organization.uuid === this.omniOrganization.uuid) {
      return false; // omni-organization can never be updated
    }
    return this.isOmniAdmin() || this.isOrganizationAdmin(organization);
  }
  canDeleteOrganization(organization) {
    if (organization.uuid === this.omniOrganization.uuid) {
      return false; // omni-organization can never be deleted
    }
    return this.isOmniAdmin(); // Only omni-admin can delete organizations
  }
  canCreateProfile(organization) {
    return this.isOmniAdmin() || this.isOrganizationAdmin(organization) || this.hasOrganizationRole(_pimAuthConstants.AdminRoles.ProfileAdmin, organization);
  }
  canUpdateProfile(profile) {
    return this.isOmniAdmin() || this.isOrganizationAdmin(profile.organization) || this.isProfileAdmin(profile) || this.hasOrganizationRole(_pimAuthConstants.ProfileRoles.Teacher, profile.organization) || this.is(profile);
  }
  canDeleteProfile(profile) {
    return this.isOmniAdmin() || this.isOrganizationAdmin(profile.organization);
  }
  canCreateGroup(organization) {
    if (organization.uuid === this.omniOrganization.uuid) {
      return false; // omni-organization cannot have groups
    }
    return this.isOmniAdmin() || this.isOrganizationAdmin(organization) || this.hasOrganizationRole(_pimAuthConstants.AdminRoles.GroupAdmin, organization) || this.hasOrganizationRole(_pimAuthConstants.ProfileRoles.Teacher, organization);
  }
  canUpdateGroup(group) {
    return this.isOmniAdmin() || this.isOrganizationAdmin(group.organization) || this.hasOrganizationRole(_pimAuthConstants.AdminRoles.GroupAdmin, group.organization) || this.isGroupAdmin(group);
  }
  canDeleteGroup(group) {
    return this.isOmniAdmin() || this.isOrganizationAdmin(group.organization);
  }
  canUpdatePassword(user) {
    return this.isOmniAdmin() || !!this.user && this.user.uuid === user.uuid;
  }
  canUpdatePasswordWithoutOld(user) {
    return this.isOmniAdmin() && !!this.user && this.user.uuid !== user.uuid; // Omni-admin can update other user's passwords without old
  }
  canCreateApplication() {
    return this.isOmniAdmin();
  }
  canDeleteApplication() {
    return this.isOmniAdmin();
  }
  canUpdateApplication(application) {
    var _this$application;
    debugLog("Checking if user can update application", application);
    debugLog("ref-application", this.application);
    return this.isOmniAdmin() || application !== undefined && ((_this$application = this.application) == null ? void 0 : _this$application.clientId) === application.clientId && this.isOrganizationAdmin(application.organization);
  }
  canCreateUser() {
    return this.isOmniAdmin() || this.isOrganizationAdmin(this.organization) || this.hasOrganizationRole(_pimAuthConstants.AdminRoles.ProfileAdmin, this.organization) || this.hasRole(_pimAuthConstants.ProfileRoles.Teacher, "Organization", this.organization.uuid);
  }
  canDeleteUser() {
    return this.isOmniAdmin();
  }
  canUpdateUser() {
    return this.isOmniAdmin();
  }
  canCreateProfileShare(profileShare) {
    if (this.isOmniAdmin()) {
      return true;
    }
    if (!this.isOrganizationAdmin(profileShare.organization)) {
      return false;
    }
    return this.organization.collaboratesWith.some(o => o.uuid === profileShare.sharedWithOrganization.uuid);
  }
  canDeleteProfileShare(profileShare) {
    return this.isOmniAdmin() || this.isOrganizationAdmin(profileShare.organization);
  }
  canUpdateProfileShare(_profileShare) {
    // Updating profile shares is not a normal use-case
    return this.isOmniAdmin();
  }
  canAcceptCollaboration(organization) {
    return this.isOmniAdmin() || this.isOrganizationAdmin(organization) || this.hasRole(_pimAuthConstants.AdminRoles.CollaborationAdmin, "Organization", organization.uuid);
  }
}
exports.default = ClaimsPermissionChecker;